/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export interface ExportResponseSuccess {
  status: 'success';
  data?: Uint8Array;
}

export interface ExportResponseFailure {
  status: 'failure';
  error: Error;
}

export interface ExportResponseRetryable {
  status: 'retryable';
  retryInMillis?: number;
  error?: Error;
}

export type ExportResponse =
  | ExportResponseSuccess
  | ExportResponseFailure
  | ExportResponseRetryable;
